define(['app/module/System/extension/validator/lang/' + _config.app.general.language], function(){
    return {};
});